import React, {useEffect, useState} from 'react';
import {Card, CardBody, Nav, NavItem,NavLink, TabContent, Table, TabPane} from 'reactstrap';
import LocalizedStrings from "react-localization";
import {common_strings} from "../../translations/common_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import {student_strings} from "../../translations/student_translations";
import {resource_strings} from "../../translations/resource_translations";
import businessHelper from "../../helpers/BusinessHelper";
import * as classnames from "classnames";
import IncomeReportRow from "../reports/IncomeReportRow";
import constants from "../../shared/constants";

let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);
let studentStrings = new LocalizedStrings(student_strings);

const IncomesAndExpenses = (props) => {
    const [incomeData, setIncomeData] = useState(props.incomeData);
    const [expenseData, setExpenseData] = useState(props.expenseData);
    const [currency, setCurrency] = useState(businessHelper.currency());
    const [tabs, setTabs] = useState(props.type === constants.cabinet.incomes ? 1 : 2);

    // useEffect(() => {
    //     alert(incomeData.length)
    // });

    function localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
        studentStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    localize();

    function renderIncomeTable() {
        if (incomeData !== null) {
            return incomeData.map((income, index) => {
                return (
                    <IncomeReportRow income={income} key={income.id} openTicket={{}} deleteTicket={{}}
                                     strings={resourceStrings} currency={currency} onIncomeSelected={e => onIncomeSelected(e, income)}/>
                )
            })
        }
    }

    function onIncomeSelected(e, income) {
        e.preventDefault();
        props.onIncomeSelected(income)
    }

    function renderExpenseTable() {
        if (expenseData !== null) {
            return expenseData.map((income, index) => {
                return (
                    <IncomeReportRow income={income} key={income.id} deleteTicket={{}}
                                     strings={resourceStrings} currency={currency} onIncomeSelected={e => onIncomeSelected(e, income)}/>
                )
            })
        }
    }

    function toggleNavs(e, index) {
        e.preventDefault();
        props.setType(index === 1 ? constants.cabinet.incomes : constants.cabinet.expenses);
        setTabs(index)
    }

    return (
        <>
            <div className="nav-wrapper">
                <Nav
                    className="nav-fill flex-column flex-md-row ml-2 mr-2"
                    id="tabs-icons-text"
                    pills
                    role="tablist"
                >
                    <NavItem style={{cursor: "pointer"}}>
                        <NavLink
                            aria-selected={tabs === 1}
                            className={classnames("mb-sm-3 mb-md-0", {
                                active: tabs === 1
                            })}
                            onClick={e => toggleNavs(e,  1)}
                            role="tab"
                        >
                            <i className="fas fa-sign-in-alt mr-2" />
                            {resourceStrings.cabinet.incomes}
                        </NavLink>
                    </NavItem>
                    <NavItem style={{cursor: "pointer"}}>
                        <NavLink
                            aria-selected={tabs === 2}
                            className={classnames("mb-sm-3 mb-md-0", {
                                active: tabs === 2
                            })}
                            onClick={e => toggleNavs(e,  2)}
                            role="tab"
                        >
                            <i className="fas fa-sign-out-alt mr-2" />
                            {resourceStrings.cabinet.expenses}
                        </NavLink>
                    </NavItem>
                </Nav>
            </div>
                    <TabContent activeTab={"tabs" + tabs}>
                        <TabPane tabId="tabs1">
                            <Table
                                className="align-items-center table-dark table-flush"
                                responsive
                            >
                                <thead className="thead-dark">
                                <tr>
                                    <th scope="col">{resourceStrings.title}</th>
                                    <th scope="col">{resourceStrings.category}</th>
                                    <th scope="col">{commonStrings.date}</th>
                                    <th scope="col">{resourceStrings.amount}</th>
                                    <th scope="col" className="text-right">{commonStrings.payment_method}</th>
                                </tr>
                                </thead>
                                <tbody>
                                {renderIncomeTable()}
                                </tbody>
                            </Table>
                        </TabPane>
                        <TabPane tabId="tabs2">
                            <Table
                                className="align-items-center table-dark table-flush"
                                responsive
                            >
                                <thead className="thead-dark">
                                <tr>
                                    <th scope="col">{resourceStrings.title}</th>
                                    <th scope="col">{resourceStrings.category}</th>
                                    <th scope="col">{commonStrings.date}</th>
                                    <th scope="col">{resourceStrings.amount}</th>
                                    <th scope="col" className="text-right">{commonStrings.payment_method}</th>
                                </tr>
                                </thead>
                                <tbody>
                                {renderExpenseTable()}
                                </tbody>
                            </Table>
                        </TabPane>
                    </TabContent>
        </>
    );
};

export default IncomesAndExpenses;